module.exports = __webpack_public_path__ + "static/media/so.2083e753.webp";